import { useQuery } from "@tanstack/react-query";
import { Response } from "openai/resources/responses/responses";
import { getResponse } from "../../api/toolCall.api";
import { Modal } from "../shared/modal";
import Typography from "../shared/typography";

interface RunStepsModalProps {
  responseId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

export function RunStepsModal({
  responseId,
  isOpen,
  onClose,
}: RunStepsModalProps) {
  const { data, isLoading, error } = useQuery<Response>({
    queryKey: ["response", responseId],
    queryFn: () => getResponse(responseId || ""),
    enabled: isOpen && !!responseId,
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Response">
      {isLoading && <Typography variant="body2">Loading...</Typography>}
      {error && (
        <Typography variant="body2" className="text-terracotta-600">
          Error loading run steps
        </Typography>
      )}
      {data && (
        <pre className="whitespace-pre-wrap text-xs max-h-[70vh] overflow-auto bg-beige-50 p-2 rounded">
          {JSON.stringify(data, null, 2)}
        </pre>
      )}
    </Modal>
  );
}
